import {translate} from 'views/module';

const generateFilterOptions = () => {
  const filterOptions = {};

  filterOptions.searchString = {
    key: 'searchString',
    label: translate('clientLead.ClientLeadList.Filter.Search'),
    rank: 0,
    type: 'text',
    options: null,
    canBeEmpty: false,
  };

  filterOptions.status = {
    key: 'status',
    label: translate('clientLead.ClientLeadList.Filter.Status'),
    rank: 1,
    options: Object.entries(translate('client.Status'))
        .filter(([key]) => key !== 'ACTIVE' && key !== 'INACTIVE')
        .reduce((acc, [key, value], index) => {
          acc[key] = {
            label: value.Title,
            rank: index + 1,
            key: key,
          };
          return acc;
        }, {
          ALL: {
            label: 'All',
            rank: 0,
            key: 'ALL',
          },
        }),
    canBeEmpty: false,
  };


  return filterOptions;
};

export {
  generateFilterOptions,
};
